import { IBank, IRSBank, BANKS_ID } from '../../store/pik_data/banks';
import { isRSBanksValid } from '../../utils/validators';
import { IconType } from '../../ui/icon/icon';
import { BankAbsolutIcon } from '../../ui/icon/icons/bank-abs';
import { BankOtkrytieIcon } from '../../ui/icon/icons/bank-otk';
import { BankSberIcon } from '../../ui/icon/icons/bank-sber';
import { BankVTBIcon } from '../../ui/icon/icons/bank-vtb';
import { BankAlfaIcon } from '../../ui/icon/icons/bank-alfa';
import { BankDomRfIcon } from '../../ui/icon/icons/bank-dom-rf';
import { ILogger } from '@cian/logger';
import { BankGazpromIcon } from '../../ui/icon/icons/bank-gazprom';
import { BankUralsibIcon } from '../../ui/icon/icons/bank-uralsib';
import { BankRaifaizenIcon } from '../../ui/icon/icons/bank-raifaizen';
import { BankRosselhozIcon } from '../../ui/icon/icons/bank-rosselhoz';
import { BankProminvestIcon } from '../../ui/icon/icons/bank-prominvest';
import { BankMKBIcon } from '../../ui/icon/icons/bank-mkb';
import { BankZenitIcon } from '../../ui/icon/icons/bank-zenit';

const iconMap: { [index: number]: IconType } = {
  [BANKS_ID.sberbank]: BankSberIcon,
  [BANKS_ID.absolute]: BankAbsolutIcon,
  [BANKS_ID.vtb]: BankVTBIcon,
  [BANKS_ID.otkrytie]: BankOtkrytieIcon,
  [BANKS_ID.alfa_bank]: BankAlfaIcon,
  [BANKS_ID.bank_dom_rf]: BankDomRfIcon,
  [BANKS_ID.gazprom]: BankGazpromIcon,
  [BANKS_ID.uralsib]: BankUralsibIcon,
  [BANKS_ID.raifaizen]: BankRaifaizenIcon,
  [BANKS_ID.zenit]: BankZenitIcon,
  [BANKS_ID.moscov_kredit_bank]: BankMKBIcon,
  [BANKS_ID.prominvest]: BankProminvestIcon,
  [BANKS_ID.rosselhozbank]: BankRosselhozIcon,
};

export const mapRSBanksToBanks = (rsBanks: IRSBank[], logger: ILogger): IBank[] => {
  const isRsBanksValid = isRSBanksValid(rsBanks, logger);

  if (!isRsBanksValid || !rsBanks || !rsBanks.length) {
    return [];
  }

  return rsBanks.map(
    (rsBank: IRSBank): IBank => {
      return {
        ...rsBank,
        icon: iconMap[rsBank.id],
      };
    },
  );
};
